<template>
  <div class="page-container">
    <h3 class="page-title">{{ $t("inventory") }}</h3>
    <div style="margin-top: 16px">
      <div style="margin-top: 18px">
        <div class="tab-switcher-container">
          <span
            v-for="(tab, index) in items"
            :key="index"
            :class="['tab-switcher', { active: activeTab === index }]"
            @click="changeTab(index, tab.id)"
          >
            {{
              tab[
                `name${
                  $i18n.locale.charAt(0).toUpperCase() + $i18n.locale.slice(1)
                }`
              ]
            }}
          </span>
        </div>
        <div class="tab-wrapper">
          <div
            v-for="(tab, index) in items"
            :key="index"
            class="table-container"
            v-if="activeTab === index"
          >
            <div class="actions_container">
              <div class="inventarization-actions">
                <div
                  v-if="
                    tab.inventarization === INVENTARIZATION_STATUSES.STOP ||
                    tab.inventarization === INVENTARIZATION_STATUSES.NOT_START
                  "
                >
                  <v-btn
                    class="btn primary"
                    style="text-transform: capitalize"
                    @click="startInventarization({ id: tab.id })"
                  >
                    <v-icon class="mr-2">mdi-menu-right</v-icon>
                    {{ $t("startInventarization") }}
                  </v-btn>
                </div>
                <div
                  v-else-if="
                    tab.inventarization === INVENTARIZATION_STATUSES.START
                  "
                  class="inv_container"
                >
                  <router-link
                    :to="{
                      name: 'omtk-inventarization-item',
                      params: { id: inventarizationTimeList[0]?.id },
                      query: {
                        type:
                          tab.id === 'my-office' ? 'forOffice' : 'notForOffice',
                      },
                    }"
                    style="text-decoration: none"
                  >
                    <button class="invbtn continue">
                      <v-icon color="primary" size="medium">mdi-pause</v-icon>
                      <span>{{ $t("continueInventarization") }}</span>
                    </button>
                  </router-link>
                  <button
                    class="invbtn finish"
                    @click="finishInventarization(tab)"
                  >
                    <v-icon color="error" size="medium"
                      >mdi-circle-off-outline</v-icon
                    >
                    {{ $t("finishInventarization") }}
                  </button>
                </div>
              </div>
            </div>
            <div style="margin-top: 24px">
              <table-with-filter
                :headers="headers"
                :items="inventarizationTimeList"
                :is-filterable="false"
              >
                <template #item.validsCount="{ item }">
                  <div style="display: flex; gap: 5px">
                    <span>
                      {{ `${item.validsCount} / ${item.totalCount}` }}
                    </span>
                    <span v-if="item.validsCount < item.totalCount">
                      <v-icon
                        color="error"
                        style="font-size: 15px"
                        v-if="item.valid !== 'VALID'"
                        >mdi-alert</v-icon
                      >
                    </span>
                  </div>
                </template>
                <template #item.status="{ item }">
                  <span class="finishBadge" v-if="item.status === 'FINISHED'">
                    {{ $t("FINISHED") }}
                  </span>
                  <span
                    class="startBadge"
                    v-else-if="item.status === 'STARTED'"
                  >
                    {{ $t("STARTED") }}
                  </span>
                </template>
                <template #item.endedAt="{ item }">
                  <span v-if="item.endedAt">{{ item.endedAt }}</span>
                  <span v-else> - </span>
                </template>
                <template #item.actions="{ item }">
                  <router-link
                    :to="{
                      name: 'omtk-inventarization-item',
                      params: { id: item.id },
                      query: {
                        type:
                          tab.id === 'my-office' ? 'forOffice' : 'notForOffice',
                      },
                    }"
                  >
                    <v-btn class="new_style">
                      <vue-icon icon="newEyeIcon"></vue-icon>
                    </v-btn>
                  </router-link>
                </template>
              </table-with-filter>
            </div>
            <div>
              <!--          <VuePagination-->
              <!--            go-to-->
              <!--            @update:limit="-->
              <!--              (limit) => {-->
              <!--                configuration.limit = limit;-->
              <!--                configuration.page = 1;-->
              <!--                changePage();-->
              <!--              }-->
              <!--            "-->
              <!--            v-model="configuration.page"-->
              <!--            :length="lastPage"-->
              <!--            @input="changePage"-->
              <!--            :limit="configuration.limit"-->
              <!--          />-->
            </div>
          </div>
        </div>
      </div>
      <!--      <table-with-filter-->
      <!--        fixed-header-->
      <!--        :height="$vuetify.breakpoint.height - 178"-->
      <!--        :headers="headers"-->
      <!--        :items="items"-->
      <!--        style="width: 100%"-->
      <!--      >-->
      <!--        <template #filter.name>-->
      <!--          <div class="d-flex pa-1">-->
      <!--            <custom-input-text-->
      <!--              style="width: 70%"-->
      <!--              @input="onChangeFilter"-->
      <!--              class="user_input no-margin"-->
      <!--              v-model="warehouseFilter.name"-->
      <!--              clearable-->
      <!--            />-->
      <!--          </div>-->
      <!--        </template>-->
      <!--        <template #item.action="{ item }">-->
      <!--          <VBtn-->
      <!--            v-if="-->
      <!--              item.inventarization === INVENTARIZATION_STATUSES.STOP ||-->
      <!--              item.inventarization === INVENTARIZATION_STATUSES.NOT_START-->
      <!--            "-->
      <!--            :to="{-->
      <!--              name: 'omtk-inventarization-item',-->
      <!--              params: { id: item.id },-->
      <!--              query: { start: true },-->
      <!--            }"-->
      <!--            color="primary"-->
      <!--            dark-->
      <!--          >-->
      <!--            <v-icon class="mr-2">mdi-arrow-right-drop-circle</v-icon>-->
      <!--            <span> {{ $t("startInventarization") }}</span>-->
      <!--          </VBtn>-->
      <!--          <VBtn-->
      <!--            left-->
      <!--            :to="{-->
      <!--              name: 'omtk-inventarization-item',-->
      <!--              params: { id: item.id },-->
      <!--              query: { start: false },-->
      <!--            }"-->
      <!--            class="btn_33 new_plus_btn"-->
      <!--            v-if="item.inventarization === INVENTARIZATION_STATUSES.START"-->
      <!--          >-->
      <!--            <v-icon class="mr-2" size="medium" color="green"-->
      <!--              >mdi-arrow-right</v-icon-->
      <!--            >-->
      <!--            <span>{{ $t("continueInventarization") }}</span>-->
      <!--          </VBtn>-->
      <!--          <VBtn-->
      <!--            class="btn_33 new_plus_btn"-->
      <!--            v-if="item.inventarization === INVENTARIZATION_STATUSES.START"-->
      <!--            @click="finishInventarization(item)"-->
      <!--          >-->
      <!--            <v-icon class="mr-2" color="error" size="medium"-->
      <!--              >mdi-circle-off-outline</v-icon-->
      <!--            >-->
      <!--            <span>{{ $t("finishInventarization") }}</span>-->
      <!--          </VBtn>-->
      <!--        </template>-->
      <!--      </table-with-filter>-->
    </div>
    <vue-pagination
      go-to
      @update:limit="
        (limit) => {
          configuration.limit = limit;
          configuration.page = 1;
          changePage();
        }
      "
      v-model="configuration.page"
      :length="lastPage"
      @input="changePage"
      :limit="configuration.limit"
    />
  </div>
</template>

<script>
import { debounce, makerPagination } from "@/utils/pureFunctions";
import TableWithFilter from "@/components/ui/table/TableWithFilter";
import VuePagination from "@/components/ui/vue-pagination/VuePagination";
import { INVENTARIZATION_STATUSES } from "@/utils/constants.js";

const DEFAULT_WAREHOUSE_FILTER = {
  name: null,
};

export default {
  name: "Inventarization",
  components: {
    VuePagination,
    TableWithFilter,
  },
  data() {
    return {
      warehouseFilter: {
        ...DEFAULT_WAREHOUSE_FILTER,
      },
      items: [],
      inventarizationTimeList: [],
      configuration: {
        limit: 10,
        page: 1,
      },
      lastPage: 0,
      selectedFilter: 2,
      activeTab: localStorage.getItem("tb-inventarization")
        ? Number(localStorage.getItem("tb-inventarization"))
        : 0,
      inventarizationId: "",
    };
  },
  computed: {
    INVENTARIZATION_STATUSES: () => INVENTARIZATION_STATUSES,
    headers() {
      return [
        {
          text: this.$t("startDate"),
          value: "startedAt",
        },
        {
          text: this.$t("endDate"),
          value: "endedAt",
        },
        {
          text: this.$t("resPerson"),
          value: "auditor",
        },
        {
          text: this.$t("status"),
          value: "status",
        },
        {
          text: this.$t("process"),
          value: "validsCount",
        },
        {
          text: this.$t("action"),
          value: "actions",
        },
      ];
    },
  },
  methods: {
    async getInventarizationDetails(warehouseId) {
      const params = {
        page: 0,
        limit: 10,
        warehouseId: warehouseId !== "my-office" ? warehouseId : null,
        forOffice: warehouseId === "my-office",
      };
      try {
        const { data } = await this.$http.get("inventarization/list", {
          params,
        });

        this.inventarizationTimeList = data.data;
      } catch (e) {
        console.log(e);
      }
    },
    async changeTab(index, tabId) {
      this.activeTab = index;
      localStorage.setItem("tb-inventarization", index);
      await this.getInventarizationDetails(tabId);
    },
    async getItems(setQuery) {
      const { page, limit } = this.configuration;
      if (setQuery) {
        await this.$router.push({
          query: { page: this.configuration.page.toString() },
        });
      }
      let params = {
        inventarization: true,
        page: page - 1,
        limit,
        ...this.warehouseFilter,
      };
      this.showLoading();
      try {
        const {
          data: { data, total },
        } = await this.$http.get("warehouse", {
          params,
        });
        this.items = data.map((item) => {
          item.name = this.translateKey(item, "name");
          return item;
        });
        let officeInvStatus = null;
        try {
          const {
            data: { data },
          } = await this.$http.get("inventarization/status-office", {});
          officeInvStatus = data.inventarization;
        } catch (e) {
          console.log(e);
        }

        this.items.push({
          nameRu: "Мой офис",
          nameEn: "My office",
          nameUz: "Mening ofisim",
          inventarization: officeInvStatus,
          id: "my-office",
        });

        this.lastPage = makerPagination({ limit, total }).lastPage;
      } catch (e) {
        this.setResponseError({ error: e });
      } finally {
        this.clearLoading();
      }
    },
    translateKey(obj, key) {
      let locale = this.$i18n.locale;
      let translatedKey = `${key}${locale[0].toUpperCase()}${locale.slice(1)}`;
      if (obj[translatedKey]) {
        return obj[translatedKey];
      }
      return obj[key];
    },
    async changePage(value) {
      const { page: queryPage } = this.$route.query;
      if (queryPage !== value.toString()) {
        this.showLoading();
        await this.$router.replace({ query: { page: value.toString() } });
        this.configuration.page = value;
        await this.getItems();
        this.clearLoading();
      }
    },
    async getFilterProductName() {
      const { page, limit } = this.configuration;
      if (this.configuration.page.toString() !== this.$route.query.page) {
        await this.$router.push({
          query: { page: this.configuration.page.toString() },
        });
      }
      let params = { page: page - 1, limit, ...this.warehouseFilter };
      this.showLoading();
      try {
        const {
          data: { data, total },
        } = await this.$http.get("warehouse/search-engine", {
          params,
        });
        if (data) {
          this.items = data.map((item) => {
            item.parentClassName = "cursor-pointer";
            return item;
          });
        }
        this.lastPage = makerPagination({ total, limit }).lastPage;
      } catch (err) {
        this.setResponseError({ error: err });
      } finally {
        this.clearLoading();
      }
    },
    onChangeFilter: debounce(function () {
      if (this.selectedFilter === 1) {
        this.getFilterProductName();
      }
      if (this.selectedFilter === 2) {
        if (this.configuration.page === 1) {
          this.getItems();
        } else {
          this.changePage(1);
        }
      }
    }, 300),
    async startInventarization({ id }) {
      if (id !== "my-office") {
        this.showLoading();
        try {
          const {
            data: { data },
          } = await this.$http.post(`inventarization/start?warehouseid=${id}`);
          this.inventarizationId = data.id;
          const idx = Number(localStorage.getItem("tb-inventarization"));
          await this.getInventarizationDetails(this.items[idx].id);
          await this.getItems();
        } catch (e) {
          this.setResponseError({ error: e });
        } finally {
          this.clearLoading();
        }
      } else {
        this.showLoading();
        try {
          const {
            data: { data },
          } = await this.$http.post("inventarization/start-office");
          this.inventarizationId = data;
          const idx = Number(localStorage.getItem("tb-inventarization"));
          await this.getInventarizationDetails(this.items[idx].id);
          await this.getItems();
        } catch (e) {
          this.setResponseError({ error: e });
        } finally {
          this.clearLoading();
        }
      }
    },
    async finishInventarization(item) {
      if (item.id !== "my-office") {
        this.showLoading();
        try {
          await this.$http.post(`inventarization/end?warehouseid=${item.id}`);
          item.inventarization = INVENTARIZATION_STATUSES.STOP;
          this.setSuccess({
            title: this.$t("inventarizationStopped", {
              warehouse: this.translateKey(item, "name"),
            }),
          });
          await this.getInventarizationDetails(item.id);
        } catch (e) {
          this.setResponseError({ error: e });
        } finally {
          this.clearLoading();
        }
      } else {
        this.showLoading();
        try {
          await this.$http.post(`inventarization/end-office`);
          item.inventarization = INVENTARIZATION_STATUSES.STOP;
          this.setSuccess({
            title: this.$t("inventarizationStopped", {
              warehouse: this.translateKey(
                item,
                `name${
                  this.$i18n.locale.charAt(0).toUpperCase() +
                  this.$i18n.locale.slice(1)
                }`
              ),
            }),
          });
          await this.getInventarizationDetails(item.id);
        } catch (e) {
          this.setResponseError({ error: e });
        } finally {
          this.clearLoading();
        }
      }
    },
  },
  async created() {
    const { page } = this.$route.query;
    if (page && !isNaN(+page)) {
      this.configuration.page = parseInt(+page);
    }
    await this.getItems();
    if (localStorage.getItem("tb-inventarization")) {
      const idx = Number(localStorage.getItem("tb-inventarization"));
      await this.getInventarizationDetails(this.items[idx].id);
    } else {
      await this.getInventarizationDetails(this.items[0].id);
    }
  },
};
</script>

<style lang="scss" scoped>
.page-title {
  font-family: "Rubik", sans-serif;
  font-size: 18px;
  font-weight: 600;
  line-height: 21.33px;
  text-align: left;
}

.inv_container {
  display: flex;
  align-items: center;
  gap: 16px;
}

.invbtn {
  border: 1px solid;
  border-radius: 6px;
  padding: 12px 16px;
  font-family: "Rubik", sans-serif;
  font-size: 12px;
  font-weight: 500;
  line-height: 14.22px;
  display: flex;
  align-items: center;
  gap: 5px;

  &.continue {
    border-color: #0096b2;
    color: #0096b2;
  }

  &.finish {
    border-color: #ff6969;
    color: #ff6969;
  }
}

.startBadge {
  padding: 8px 10px;
  background: #fae7cb;
  color: #d28712;
  border-radius: 6px;
  font-family: "Rubik", sans-serif;
  font-size: 12px;
  font-weight: 500;
  line-height: 14.22px;
}

.finishBadge {
  padding: 8px 10px;
  background: #a2f6a0;
  color: #178015;
  border-radius: 6px;
  font-family: "Rubik", sans-serif;
  font-size: 12px;
  font-weight: 500;
  line-height: 14.22px;
}
.table-container {
  border: 1px solid #e3ebf3;
  background-color: #fff;
  padding: 24px;
}

.tab-switcher-container {
  display: flex;
  gap: 8px;

  .tab-switcher {
    background-color: #fafbfc;
    padding: 8px 12px;
    border-radius: 6px 6px 0 0;
    border: 1px solid #e3ebf3;
    border-bottom: none;
    cursor: pointer;

    &.active {
      background-color: #fff;
      position: relative;

      &::after {
        content: "";
        position: absolute;
        width: 100%;
        height: 3px;
        background-color: #fff;
        bottom: -2px;
        left: 0;
      }
    }
  }
}

.add_product_btn {
  background-color: #0096b2;
  color: #fff;
  padding: 8px 10px;
  border-radius: 6px;
}

.badge {
  border-radius: 6px;
  padding: 8px 10px;
  background-color: #e3e6eb;
  color: #647182;

  &.badgeSuccess {
    background-color: #a2f6a0;
    color: #178015;
  }
}

.model_container {
  background-color: #fff;
  padding: 24px;

  span {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .modalForm {
    display: flex;
    flex-direction: column;
    gap: 18px;
    margin-top: 20px;

    input {
      width: 100%;
    }
  }
}

.v-enter-active,
.v-leave-active {
  transition: opacity 0.5s;
}

.v-enter,
.v-leave {
  opacity: 0;
}

.errorSelect .vue-select__wrap .vue-select__input {
  border: 1px solid red !important;
}

.errorInput {
  border-color: red;
  -webkit-box-shadow: inset 3px 0px 63px -31px rgba(255, 0, 0, 0.355);
  -moz-box-shadow: inset 3px 0px 63px -31px rgba(255, 0, 0, 0.355);
  box-shadow: inset 3px 0px 63px -31px rgba(255, 0, 0, 0.355);
}

.error-text {
  height: 10px;
  font-size: 12px;
  color: red;
  font-family: "Rubik", sans-serif;
  margin-top: 5px;
}
</style>
